import { templateActionTypes } from '../actions/types';
import _ from 'lodash';

const initialState = {
  count: 0,
  templateId: null,
  templates: [],
  template: {},
  templateSkip: null,
  // templateLimit: 16,
  hasMoreTemplate: true,
  status: '',
};

export function template(state = initialState, action) {
  switch (action.type) {
    case templateActionTypes.RESET_STATE:
      return {
        ...initialState,
      };
    case templateActionTypes.SEARCH_REQUEST:
      if (action.tag) {
        return {
          ...state,
          [`${action.tag}Status`]: 'loading',
        };
      } else {
        return {
          ...state,
          status: 'loading',
        };
      }
    case templateActionTypes.SEARCH_SUCCESS:
      if (typeof action.templates === 'number') {
        return {
          ...state,
          count: action.templates,
        }
      } else if (action.tag) {
        return {
          ...state,
          [`${action.tag}`]: action.clear
            ? action.templates
            : [..._.get(state, `${action.tag}`, []), ...action.templates],
          [`${action.tag}Skip`]: action.skip,
          [`${action.tag}Limit`]: action.limit,
          [`hasMore${action.tag}`]: action.clear ? true : action.templates.length !== 0,
          [`${action.tag}Status`]: 'success',
        };
      } else {
        return {
          ...state,
          templates: action.clear ? action.templates : [...state.templates, ...action.templates],
          templateSkip: action.skip,
          templateLimit: action.limit,
          hasMoreTemplate: action.clear ? true : action.templates.length !== 0,
          status: 'success',
        };
      }
    case templateActionTypes.SEARCH_FAILURE:
      if (action.tag) {
        return {
          ...state,
          [`${action.tag}Error`]: action.error,
          [`${action.tag}Status`]: 'failure',
        };
      } else {
        return {
          ...state,
          error: action.error,
          status: 'failure',
        };
      }
    case templateActionTypes.FETCH_REQUEST:
      return {
        ...state,
        status: 'loading',
      };
    case templateActionTypes.FETCH_SUCCESS:
      return {
        ...state,
        template: action.template,
        status: 'success',
      }
    case templateActionTypes.FETCH_FAILURE:
      return {
        ...state,
        error: action.error,
        status: 'failure',
      };
    case templateActionTypes.UPDATE_REQUEST:
      return {
        ...state,
        status: 'loading',
      };
    case templateActionTypes.UPDATE_SUCCESS:
      const index = state.templates.findIndex(element => element.data.id === action.template.data.id);
      const updatedList = [...state.templates];
      if (index > -1) updatedList[index] = { ...action.template, key: updatedList[index].key }
      return {
        ...state,
        status: 'success',
        template: {
          ...state.template,
          ...action.template.data,
          _id: action.template.data.id,
        },
        templates: updatedList,
      }
    case templateActionTypes.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
        status: 'failure',
      };
    case templateActionTypes.CREATE_REQUEST:
      return {
        ...state,
        status: 'loading',
      };
    case templateActionTypes.CREATE_SUCCESS:
      return {
        ...state,
        status: 'success',
        templateId: action.templateId
      }
    case templateActionTypes.CREATE_FAILURE:
      return {
        ...state,
        error: action.error,
        status: 'failure',
      };
    case templateActionTypes.SELECT_TEMPLATE:
      return {
        ...state,
        templateId: action.templateId,
      };
    default:
      return state;
  }
}
